<template>
  <div class="centered">
    <div class="container mb-auto mt-auto">
      <form class="form-signin">
        <div class="card mx-auto card-auth border-0">
          <div class="card-body">
            <div class="text-center">
              <router-link to="/">
                <img src="/img/mpower_logo_text_nopad.png" class="logo-h mb-3" alt="MPower Promo" />
              </router-link>
              <h3 class="my-3">{{ title }}</h3>
            </div>
            <span id="reauth-email" class="reauth-email"></span>
            <div v-if="err.length" class="alert alert-danger">
              <div v-for="error in err" :key="error" v-html="error" />
            </div>
            <div class="form-group">
              <PasswordInput
                label="New Password"
                v-model="newPasswordFirst"
                v-validate="'required|passwordRules'"
                name="password"
                autocomplete="off"
                ref="password"
                :showValidation="true"
              />
            </div>

            <div class="form-group">
              <PasswordInput
                label="Confirm New Password"
                v-model="newPasswordSecond"
                v-validate="'required|confirmed:password'"
                name="confirm_password"
                autocomplete="off"
                data-vv-as="Password Confirmation"
                :showValidation="false"
              />
              <div class="invalid-feedback d-block">{{ errors.first('confirm_password') }}</div>
            </div>
          </div>
          <div class="card-body">
            <button @click.prevent="setNewPassword" class="btn btn-primary" :disabled="errors.any()">
              <i v-if="loading" class="far fa-spinner-third fa-spin"></i> Save Password
            </button>
            <a class="btn btn-link" @click="$router.push({ name: 'auth/forgot' })">Cancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: 'Create New Password',
      newPasswordFirst: '',
      newPasswordSecond: '',
      err: [],
      loading: false,
      token: ''
    };
  },
  created() {
    if (this.$route.name !== 'auth/registration') {
      this.token = this.$route.query.token;
    } else {
      this.title = 'Create Password';
      this.token = this.$route.params.token;
    }
    if (!this.token) this.err.push('There is no token for password.');
  },
  methods: {
    async setNewPassword() {
      try {
        await this.$validator.validateAll();
        if (this.errors.any()) {
          this.err = [];
          this.err = [...this.errors.items.map((err) => err.msg)];
          return;
        }
        this.loading = true;
        await this.http.post('/users/newPassword', {
          token: this.token,
          newPassword: this.newPasswordFirst
        });
        this.loading = false;
        this.$router.push({ name: 'auth/signin' });
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.err.push(error.data.message);
      }
    }
  },
  components: {
    PasswordInput: () => import('@/components/PasswordInput')
  }
};
</script>
